import { isString, startsWith, some } from 'lodash';

import { TYPES } from 'constants/merchandising';

const UNISIZE_PRODUCTS_IDS = ['SL1', 'EM1', 'GIFTWOOD', 'KOOZIE'];

const Sku = class {
  /**
   * Returns the size portion of a SKU; the last 2 or 3 characters of the sku.
   *
   * @param sku
   * @param productType - optional, currently only used for TYPES.SOCKS
   * @returns {string|*}
   */
  static getSizeCodeBySku = (sku, productType) => {
    // Return empty string for unisize product SKU's
    if (!isString(sku) || some(UNISIZE_PRODUCTS_IDS, productId => startsWith(sku, productId))) {
      return '';
    }
    return productType === TYPES.SOCKS ? sku.slice(-2) : sku.slice(-3);
  };
};

export default Sku;
